export const APP_ROUTES = {
    LOGIN: "login",
    DASHBOARD: "dashboard",
    EMPLOYEE: {
        ROOT: "employee",
        HISTORY: "history",
        CREATION: "creation"
    },
    TRAINING: {
        ROOT: "training",
        HISTORY: "history",
        CREATION: "creation",
        HISTORY_ROUTES: {
            EDIT: "edit",
            REPORT: "report"
        }
    },
    TRAININGSESSION: {
        ROOT: "trainingSession",
        HISTORY: "history",
        CREATION: "creation",
        HISTORY_ROUTES: {
            FEEDBACK: "feedBack",
            ATTENDANCE: "attendance",
            SISSIONPLAN_HISTORY: "sessionPlan_History"
        }
    },
    SOILREPORT: {
        ROOT: "soilReport",
        HISTORY: "history",
        CREATION: "creation",
        SUMMARYREPORT: "summaryReport",
        HISTORY_ROUTES: {
            EDIT: "edit",
            VILLAGEEDIT:"villageEdit"
        }
    },
    FIELDBOOK: {
        ROOT: "field_book",
        HISTORY: "history",
        CREATION: "creation",
        SUMMARYREPORT: "summaryReport",
        HISTORY_ROUTES: {
            EDIT: "edit"
        }
    },
    ADOPTION: {
        ROOT: "adOption",
        HISTORY: "history",
        CREATION: "creation",
        SUMMARYREPORT: "summaryReport",
        OVERALSUMMARY: "overalSummary",
        HISTORY_ROUTES: {
            EDIT: "edit"
        }
    },
    PROFILE: "profile",
    PAGENOTFOUND: "*"
};
